<template>
  <div class="background">
    <KeepAlive>
      <NavMenu v-if="isAuthenticated && isMenuVisible"></NavMenu>
    </KeepAlive>
    <slot></slot>
  </div>
</template>

<script setup>
import { computed, watch, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import NavMenu from '../components/navigation/NavMenu.vue';

const store = useStore();
const route = useRoute();

const isAuthenticated = computed(() => store.getters['userStore/isAuthenticated']);
const isMenuVisible = ref(false);

const ValidRoutes = [
  'home',
  'resources',
];

watch(() => route.name, (newRouteName) => {
  const routeName = newRouteName.toLowerCase();
  isMenuVisible.value = ValidRoutes.includes(routeName);
});

</script>

<style>
  .background {
    background-image: url('../assets/images/LincolnDashboardLogo.png');
    background-position: center top;
    background-repeat: no-repeat;
    background-size: 400px;
    width: 100%;
    border: 1px solid transparent;
  }

  @media only screen and (max-width: 820px) {
    .background {
      background-size: 300px;
    }
  }

</style>
